import { defineMessages } from 'react-intl';

export const consultationOptionsMessages = defineMessages({
  reorderButton: {
    id: 'consultationOptions.reorderButton',
    defaultMessage: 'Re-order',
  },
  reorderError: {
    id: 'consultationOptions.reorder.error',
    defaultMessage: 'Failed to re-order the consultation. Please try again.',
  },
  cancelButton: {
    id: 'consultationOptions.cancelButton',
    defaultMessage: 'Cancel',
  },
  deleteButton: {
    id: 'consultationOptions.deleteButton',
    defaultMessage: 'Delete',
  },
  restoreButton: {
    id: 'consultationOptions.restoreButton',
    defaultMessage: 'Restore',
  },
  transferButton: {
    id: 'consultationOptions.transferButton',
    defaultMessage: 'Transfer',
  },
  transferTitle: {
    id: 'consultationOptions.transfer.title',
    defaultMessage: 'Transfer consultation',
  },
  transferSelectDoctor: {
    id: 'consultationOptions.transfer.selectDoctor',
    defaultMessage: 'Select doctor',
  },
  transferConfirmButton: {
    id: 'consultationOptions.transfer.confirmButton',
    defaultMessage: 'Transfer',
  },
  transferError: {
    id: 'consultationOptions.transfer.error',
    defaultMessage: 'Failed to transfer the consultation. Please try again.',
  },
  archiveButton: {
    id: 'global.archive',
    defaultMessage: 'Archive',
  },
  archiveError: {
    id: 'transcriptor.hideConsultation.error',
    defaultMessage: 'Failed to hide the consultation. Please try again.',
  },
  restoreError: {
    id: 'consultationOptions.restore.error',
    defaultMessage: 'Failed to restore the consultation. Please try again.',
  },
  citationsTitle: {
    id: 'consultationOptions.citations.title',
    defaultMessage: 'Citations',
  },
  citationsClose: {
    id: 'consultationOptions.citations.close',
    defaultMessage: 'Close',
  },
  addDocumentsButton: {
    id: 'consultationOptions.addDocuments.button',
    defaultMessage: 'Add document',
  },
  addDocumentsTitle: {
    id: 'consultationOptions.addDocuments.title',
    defaultMessage: 'Add documents',
  },
  addDocumentsDescription: {
    id: 'consultationOptions.addDocuments.description',
    defaultMessage: 'Select the documents to add to this consultation.',
  },
  addDocumentsError: {
    id: 'consultationOptions.addDocuments.error',
    defaultMessage: 'Failed to add documents. Please try again.',
  },
});
